module.exports = __webpack_public_path__ + "static/media/u39_5.00269b37.mp3";